"use client";

import Link from 'next/link';
import { sidebarStore } from '../../stores';
import { useEffect } from 'react';

type MenuSidebarProps = {
    category: 'ITS' | 'UTM' | 'ALL';
};

const commonLinkStyles = "block px-6 py-4 text-lg relative overflow-hidden group border-b border-gray-300 pb-2";
const commonTextStyles = "text-[14px] font-bold relative z-10 text-primary flex items-center justify-between";

const selectedLinkStyles = "bg-blue-500 text-white";

const MenuSidebar: React.FC<MenuSidebarProps> = ({ category }) => {
    const { selectedItem, setSelectedItem } = sidebarStore();
    const handleClick = (item: string ) => {
        setSelectedItem(item);
    };

    const renderLink = (href: string, text: string, item: string) => (
        <Link
            href={href}
            className={`${commonLinkStyles} ${selectedItem === item ? selectedLinkStyles : ''} relative`}
            onClick={() => handleClick(item)}
        >
            <div className={commonTextStyles}>
                <div>{text}</div>
                {selectedItem === item && <div className="fa-fas-arrow"></div>}
            </div>
            <div
                className={`absolute inset-0 bg-gradient-to-r from-blue-700 to-blue-900 transition-all duration-300 ${selectedItem === item || `group-hover:animate-fillGauge`}`}
                style={{ width: selectedItem === item ? '100%' : '0%' }}
            >
                <div
                    className={`absolute inset-0 bg-gradient-to-r from-blue-700 to-blue-900 ${selectedItem === item || 'group-hover:animate-fillGauge'}`}
                ></div>
            </div>
        </Link>
    );


    return (
        <div className="bg-white border border-gray-300 shadow-lg rounded-lg overflow-hidden z-40 w-[300px] hidden xl:block">
            <div className='p-5'>
                {category === 'ALL' || category === 'UTM' ? (
                    <>
                        {renderLink("/solution/utm/video", "화상감시시스템", "video")}
                        {renderLink("/solution/utm/fence", "울타리침입시스템", "fence")}
                        {renderLink("/solution/utm/fire", "화재감시시스템", "fire")}
                        {renderLink("/solution/utm/environment", "환경감시시스템", "environment")}
                    </>
                ) : null}

                {category === 'ALL' || category === 'ITS' ? (
                    <>
                        {renderLink("/solution/its/turnnel", "터널유고시스템", "turnnel")}
                        {renderLink("/solution/its/road", "도로감시시스템", "road")}
                        {renderLink("/solution/its/wireLess", "무선중계통합시스템", "wireLess")}
                    </>
                ) : null}
                
            </div>
        </div>
    );
};

export default MenuSidebar;
